// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"CancelSearch_ButtonGroup__Ve8L0","ButtonRight":"CancelSearch_ButtonRight__nA1Fp"};